// --------------------------------------------------------
// ADD BUTTON FIELD - AddButtonField
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import React from 'react'
import Colors from '../../../../../../constants/Colors'
import { AddButton } from './DetailsAttendanceRecord.styled'
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// ADD BUTTON FIELD INTERFACE
// --------------------------------------------------------

interface IAddButtonField {
    buttonText: string;
    onClickFunction: ()=>void;
}
/**
/**
 * A component that renders a Component description here.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const AddButtonField = ({ onClickFunction, buttonText }: IAddButtonField) => {
    // --------------------------------------------------------
    // ADD BUTTON FIELD PRIVATE DECLARATIONS
    // --------------------------------------------------------


    // --------------------------------------------------------

    // --------------------------------------------------------
    // REACT RETURN FUNCTION
    // --------------------------------------------------------
    return (
        <>
            <AddButton
                onClick={onClickFunction}
                backgroundColor={Colors.WHITE}
                color={Colors.SPM500}
                borderColor={Colors.SPM500}
            >
                <AddCircleOutlineIcon />{buttonText}
            </AddButton>
        </>
    )
    // --------------------------------------------------------
}

export default AddButtonField